import { func_datetime, func_validation } from "functions";

export default function useExportData() {
    return function exportData(data, productCode, companyId) {
        console.log("=== EXPORT CLICKED ===");
        console.log("Data:", data);
        console.log("Data length:", data?.length);
        console.log("Product Code:", productCode);
        console.log("Company ID:", companyId);
        
        if (!data || data.length === 0) {
            console.log("No data to export - exiting");
            return;
        }

        // Define columns based on product code
        const isLoyaltyLite = productCode === "Loyalty Lite";
        const isLiveOrder = productCode === "XLO001";
        const isCompanyIdFiltered = companyId !== null && companyId !== undefined && companyId !== "";

        console.log("isLoyaltyLite:", isLoyaltyLite);
        console.log("isLiveOrder:", isLiveOrder);
        console.log("isCompanyIdFiltered:", isCompanyIdFiltered);

        let csvContent = "data:text/csv;charset=utf-8,";
        
        // CSV Headers based on product code
        let headers = ["Company ID"];
        
        if (!isLoyaltyLite) {
            headers.push("Location ID");
        }
        
        headers.push("Product Code", "Go Live", "Activation Date", "Deactivation Date");
        
        if (!isLiveOrder) {
            headers.push("Activator Code", "Activator Name");
        }
        
        // Add TotalActiveOutlet and Reference for Loyalty Lite when Company ID is filtered
        if (isLoyaltyLite && isCompanyIdFiltered) {
            headers.push("Total Active Outlet", "Reference");
        }

        if (isLiveOrder && isCompanyIdFiltered) {
            headers.push("Location Name", "Live Order Count");
        }
        
        csvContent += headers.join(",") + "\n";
        console.log("Headers:", headers);

        // CSV Rows
        data.forEach((row) => {
            let rowData = [];
            
            rowData.push(row.CompanyId || "");
            
            if (!isLoyaltyLite) {
                rowData.push(`"${row.LocationId || ""}"`);
            }
            
            rowData.push(row.ProductCode || "");
            rowData.push(row.GoLive ? "Live" : "Not Live");
            
            let activationDate = "-";
            if (func_validation.isStringTrimNotEmpty(row.ActivationDate)) {
                activationDate = func_datetime.convertDateTimeToLocal(row.ActivationDate, "DD/MM/YYYY HH:mm");
            }
            rowData.push(activationDate);
            
            let deactivationDate = "-";
            if (func_validation.isStringTrimNotEmpty(row.DeactivationDate)) {
                deactivationDate = func_datetime.convertDateTimeToLocal(row.DeactivationDate, "DD/MM/YYYY HH:mm");
            }
            rowData.push(deactivationDate);
            
            // if (!isLoyaltyLite) {
            //     let count = "-";
            //     if (func_validation.isNumberValid(row.LiveOrderTransactionCount)) {
            //         count = row.LiveOrderTransactionCount;
            //     }
            //     rowData.push(count);
            // }
            
            if (!isLiveOrder) {
                rowData.push(row.ActivatorCode || "");
                rowData.push(row.ActivatorName || "");
            }
            
            // Add TotalActiveOutlet and Reference for Loyalty Lite when Company ID is filtered
            if (isLoyaltyLite && isCompanyIdFiltered) {
                rowData.push(row.TotalActiveOutlet || "0");
                
                // Format Reference data (Dictionary<string, int>) as pipe-separated with line breaks
                let referenceStr = "";
                if (row.Reference && typeof row.Reference === 'object') {
                    const referenceEntries = Object.entries(row.Reference).map(([outlet, count]) => `${outlet}: ${count}`);
                    referenceStr = `"${referenceEntries.join(' | \n')}"`;
                } else {
                    referenceStr = "-";
                }
                rowData.push(referenceStr);
            }

            if (isLiveOrder && isCompanyIdFiltered) {
                rowData.push(row.LocationName || "");
                let count = "-";
                if (func_validation.isNumberValid(row.LiveOrderTransactionCount)) {
                    count = row.LiveOrderTransactionCount;
                }
                rowData.push(count);
            }

            csvContent += rowData.join(",") + "\n";
        });

        console.log("CSV Content Preview:", csvContent.substring(0, 200));

        // Generate timestamp for filename - using simple Date methods
        const now = new Date();
        const timestamp = now.getFullYear() + 
                         String(now.getMonth() + 1).padStart(2, '0') + 
                         String(now.getDate()).padStart(2, '0') + '_' +
                         String(now.getHours()).padStart(2, '0') + 
                         String(now.getMinutes()).padStart(2, '0') + 
                         String(now.getSeconds()).padStart(2, '0');
        
        // Download CSV
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        const filename = `activation_log_${productCode}_${timestamp}.csv`;
        link.setAttribute("download", filename);
        
        console.log("Downloading file:", filename);
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        console.log("=== EXPORT COMPLETED ===");
    };
}